import { computed, ref, toRaw, watch } from 'vue'

import axios from 'axios'

const company_areas = ref([])
const company_area_filters = ref({})
const filtered_company_areas = ref([])

export default function useCompanyAreas() {
  const listCompanyAreas = async (company_id) => {
    await axios
      .get('/api/company_areas/all', { params: { company_id: company_id } })
      .then(function (response) {
        company_areas.value = filtered_company_areas.value = response.data.data
      })
      .catch(function () {})
  }

  const listCompanyAreasBySector = async (sector_id) => {
    await axios
      .get('/api/company_areas/all-by-sector', {
        params: { company_sector_id: sector_id },
      })
      .then(function (response) {
        company_areas.value = filtered_company_areas.value = response.data.data
      })
      .catch(function () {})
  }

  const updateCompanyAreaFilters = async () => {
    let filters = toRaw(company_area_filters.value)

    filtered_company_areas.value = company_areas.value.filter((row) => {
      let company_area = toRaw(row)
      let matches = 0

      for (let key of Object.keys(filters)) {
        if (filters[key].toString().trim() == '') {
          matches++
          continue
        }

        if (
          company_area[key]
            .toString()
            .trim()
            .toLowerCase()
            .normalize('NFD')
            .replace(new RegExp(/[\u0300-\u036f]/, 'gi'), '')
            .includes(
              filters[key]
                .toString()
                .trim()
                .toLowerCase()
                .normalize('NFD')
                .replace(new RegExp(/[\u0300-\u036f]/, 'gi'), ''),
            )
        ) {
          matches++
        }
      }

      return matches == Object.keys(filters).length
    })
  }

  const clearFilteredCompanyAreas = () => {
    filtered_company_areas.value = []
  }

  watch(company_area_filters.value, () => {
    updateCompanyAreaFilters()
  })

  return {
    company_areas: computed(() => company_areas.value),
    filtered_company_areas: computed(() => filtered_company_areas.value),
    company_area_filters: company_area_filters,
    listCompanyAreas,
    listCompanyAreasBySector,
    clearFilteredCompanyAreas,
  }
}
